import { PageFrame } from "../layout/PageFrame";
import type { ReactNode } from "react";
import { Space, Typography } from "../ui";
import { appShellMetrics, spacing } from "../layout/spacing";
import { windowHeight } from "../theme/displayZoom";

export type OnboardingBrand = { name: string; logo?: string };

export const ONBOARDING_PAGE_MAX_WIDTH = "80rem";

/** Page frame without app shell, shared by the public plans page and the setup page. */
export function OnboardingPageFrame({ brand, title, subtitle, extra, children }: {
  brand?: OnboardingBrand; title: ReactNode; subtitle?: ReactNode; extra?: ReactNode; children: ReactNode;
}) {
  return <PageFrame maxWidth={ONBOARDING_PAGE_MAX_WIDTH} style={{ marginInline: "auto", padding: spacing.pageGap, minHeight: windowHeight("100dvh") }} objectTitle={title} subtitle={subtitle} extra={extra} breadcrumb={brand && <Space size={spacing.tightGap} style={{ marginBottom: spacing.sectionGap }}>
      {brand.logo && <img src={brand.logo} alt="" height={appShellMetrics.logoHeight} />}
      <Typography.Text strong>{brand.name}</Typography.Text>
    </Space>}>

    {children}
  </PageFrame>;
}
